import axios from '../api'

const getPayOrderInfo = (params) => axios({ url: `/eos/coupon/orderManager/getPayOrderInfo`, params })
const getPayLinkInfo = (params) => axios({ url: `/eos/coupon/fund/recharge`, data: params, method: 'post', timeout: 60000 })
const getRechargeStatus = (params) => axios({ url: `/eos/coupon/fund/getRechargeStatus`, params })
const payByBalance = (params) => axios({ url: `/eos/coupon/fund/payByBalance`, params })
export default {
  getPayOrderInfo,
  getPayLinkInfo,
  getRechargeStatus,
  payByBalance
}
